<template>
  <v-card-text class="notification-wrapper" style="height: 100%">
    <h5 class="text-center"><b>Actualización IEL</b></h5>
    <br />
    <div class="notification-content" v-html="processedContent"></div>

    <v-card-actions v-if="showCheckbox" class="d-flex justify-center">
      <v-checkbox
        v-model="localDontShowAgain"
        label="No volver a mostrar"
        class="text-center"
      />
    </v-card-actions>
  </v-card-text>
</template>

<script>
  export default {
    name: 'SystemNotification',
    props: {
      content: {
        type: String,
        required: true,
      },
      showCheckbox: {
        type: Boolean,
        default: false,
      },
      dontShowAgain: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        processedContent: '',
      };
    },
    computed: {
      localDontShowAgain: {
        get() {
          return this.dontShowAgain;
        },
        set(value) {
          if (this.showCheckbox) {
            this.$store.commit('userNotification/SET_DONT_SHOW_AGAIN', value);
          }
        },
      },
    },
    watch: {
      content(newContent) {
        this.processedContent = this.alignCenter(newContent);
      },
    },
    created() {
      this.processedContent = this.alignCenter(this.content);
    },
    methods: {
      alignCenter(content) {
        const div = document.createElement('div');
        div.innerHTML = content;
        div.querySelectorAll('p').forEach((p) => {
          const hasInlineAlignment = p.style.textAlign;
          const hasAlignmentClass =
            p.classList.contains('is-align-left') ||
            p.classList.contains('is-align-center') ||
            p.classList.contains('is-align-right');

          if (!hasInlineAlignment && !hasAlignmentClass) {
            p.classList.add('is-align-center');
          }
        });

        div.querySelectorAll('img').forEach((img) => {
          if (!img.parentElement.classList.contains('img-wrapper')) {
            const wrapper = document.createElement('div');
            wrapper.classList.add('img-wrapper', 'is-align-center');
            img.parentNode.insertBefore(wrapper, img);
            wrapper.appendChild(img);
          }
        });

        return div.innerHTML;
      },
    },
  };
</script>

<style scoped>
  .notification-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    text-align: center;
  }

  .notification-content :deep(p) {
    margin-bottom: 0.5em;
  }

  .notification-content :deep(.is-align-left) {
    text-align: left !important;
  }

  .notification-content :deep(.is-align-center) {
    text-align: center !important;
  }

  .notification-content :deep(.is-align-right) {
    text-align: right !important;
  }

  h5 {
    color: #000000;
  }

  h6 {
    color: #00000099;
  }

  .notification-content :deep(.img-wrapper) {
    text-align: center;
    margin: 1em 0;
  }

  .notification-content :deep(img) {
    max-width: 100%;
    height: auto;
    border-radius: 6px;
  }
</style>
